import { useCallback } from "react";
import useWorkspaceApiCall from "hooks/useWorkspaceApiCall";
import { makeUserPatron } from "api/services/user-service";
import { PatronType } from "api/models/request/IMakeUserPatronRequest";

export const useMakeUserPatron = () => {
    const { callAPI, loading } = useWorkspaceApiCall(makeUserPatron, '', 'makeUserPatron.error');

    const makeUserPatronCall = useCallback(async (userId: string, patronType: PatronType) => {
        return await callAPI({ userId, patronType });
    }, [callAPI]);

    return { makeUserPatron: makeUserPatronCall, makingUserPatron: loading };
}